import _each from "lodash/each";
import store from "~/js/store/store";
import { gsap, Quint, Circ, Cubic } from "gsap";
export default class Anchorlink {
  constructor() {
    this.setup();
  }
  setup() {
    const anchors = document.querySelectorAll(".js-anchorlink");
    _each(anchors, (elm, index) => {
      elm.addEventListener("click", (event) => {
        let target = elm.getAttribute("data-anchorlink");
        let offsetY = elm.getAttribute("data-offsetY");
        if (target) {
          event.preventDefault();
          this.scrollto(target, offsetY || 0);
        }
      });
    });
  }

  // "#id" は getElementById で要素を解決する（id に ' . などが含まれると querySelector が不正セレクタで失敗するため）
  resolveTarget(target) {
    if (typeof target === "string" && target.length > 1 && target.charAt(0) === "#") {
      const el = document.getElementById(target.slice(1));
      if (el) return el;
    }
    return target;
  }

  scrollto(target, offsetY = 0) {
    try {
      gsap.to(window, {
        ease: Cubic.easeInOut,
        delay: 0.1,
        duration: 0.8,
        overwrite: true,
        scrollTo: {
          y: this.resolveTarget(target),
          offsetY: offsetY,
          autoKill: false
        }
      });
    } catch (e) {
      console.log(e);
    }
  }
}
